package com.islamicmedia.site.pages

import androidx.compose.runtime.Composable
import com.islamicmedia.site.theme.CardElevatedShadow
import com.islamicmedia.site.theme.Gray500
import com.islamicmedia.site.theme.Gray900
import com.islamicmedia.site.theme.PageBg
import com.islamicmedia.site.theme.ScoreGreen
import com.islamicmedia.site.theme.ScoreGreenBg
import com.varabyte.kobweb.core.Page
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*

/**
 * Landing page for the "update your card" flow's return_url (both the happy path from
 * /update-card and Stripe's own redirect back after a 3-D Secure step).
 *
 * This page is a SIGNAL, not a worker: it makes no API call of any kind. The mobile app watches
 * its own WebView for navigation to this path and performs the actual "apply the new card"
 * against our server itself, using its own auth token — this page has no session and nothing to
 * authenticate with, so it could not do that even if it tried. It exists purely so the app has a
 * URL to watch for.
 *
 * `setup_intent` arrives on the query string (Stripe appends it to return_url), but it is
 * deliberately never read here — this page renders nothing from it. It stays in the URL
 * untouched so the app's WebView observer can read it off the navigation event itself.
 */
@Page("/card-updated")
@Composable
fun CardUpdatedPage() {
    Div(attrs = {
        style {
            display(DisplayStyle.Flex)
            flexDirection(FlexDirection.Column)
            alignItems(AlignItems.Center)
            justifyContent(JustifyContent.Center)
            property("min-height", "100vh")
            backgroundColor(PageBg)
            padding(24.px)
            property("box-sizing", "border-box")
            property("font-family", "system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif")
        }
    }) {
        Div(attrs = {
            style {
                backgroundColor(Color.white)
                borderRadius(24.px)
                property("box-shadow", CardElevatedShadow)
                padding(28.px)
                property("width", "min(94%, 420px)")
                property("box-sizing", "border-box")
                property("text-align", "center")
            }
        }) {
            Div(attrs = {
                style {
                    width(64.px)
                    height(64.px)
                    borderRadius(50.percent)
                    backgroundColor(ScoreGreenBg)
                    display(DisplayStyle.Flex)
                    alignItems(AlignItems.Center)
                    justifyContent(JustifyContent.Center)
                    fontSize(32.px)
                    color(ScoreGreen)
                    property("margin", "0 auto 20px")
                }
            }) { Text("✓") }

            H1(attrs = {
                style {
                    property("margin", "0 0 8px")
                    fontSize(22.px)
                    fontWeight(700)
                    color(Gray900)
                }
            }) { Text("Card saved") }

            P(attrs = {
                style {
                    property("margin", "0")
                    fontSize(15.px)
                    lineHeight(1.5.em)
                    color(Gray500)
                }
            }) { Text("You can close this tab and return to Fitrah Filter.") }
        }
    }
}
